export default "__VITE_ASSET__qQqufoQ3__"